/**
 * @file wallet.js
 * @description 钱包模块API接口
 * @module api/wallet
 */
import { BASE_URL } from "../config/index.js";
import ajax from "../request.js";

/**
 * 获取账户信息
 * @param {Object} params 请求参数
 * @returns {Promise} { availableAmount, dailyLimit, minAmount, feeRate }
 */
export const getAccountInfo = (params) => {
  return ajax({
    url: "/api/account/info",
    method: "get",
    params,
  });
};

export const getWithdrawMinLimit = (params) => {
  return ajax({
    url: "/api/ext/config/withdraw/minlimit",
    method: "get",
    params,
  });
};

/**
 * 获取账单列表
 * @param {Object} params 请求参数
 * @returns {Promise} { list, total }
 */
export const getBillList = (params) => {
  return ajax({
    url: "/api/bill/page",
    method: "post",
    data: params,
  });
};

export const getBillDetail = (id) => {
  return ajax({
    url: `/api/bill/detail/${id}`,
    method: "get",
  });
};

/**
 * 获取订单列表
 * @param {Object} params 请求参数
 * "orderStatus": 2,
 * "userName": "王老五",
 * "pageNum": 1,
 * "pageSize": 10,
 * @returns {Promise} { list, total }
 */
export const getOrderList = (params) => {
  return ajax({
    url: "/api/ext/order/manager/page",
    method: "post",
    data: params,
  });
};

export const getOrderDetail = (id) => {
  return ajax({
    url: `/api/ext/order/detail/${id}`,
    method: "get",
  });
};

export const getOrderStatistics = (id) => {
  return ajax({
    url: `/api/ext/order/statistics/${id}`,
    method: "get",
  });
};

export const getOrderCustomerList = (params) => {
  return ajax({
    url: "/api/ext/order/customer/page",
    method: "post",
    data: params,
  });
};

export const applyRefundCancel = (orderId) => {
  return ajax({
    url: `/api/ext/order/applyRefundCancel/${orderId}`,
    method: "get",
  });
};

export const orderCancel = (orderId) => {
  return ajax({
    url: `/api/ext/order/orderCancel/${orderId}`,
    method: "post",
  });
};

export const orderAggreeAllRefund = (params) => {
  return ajax({
    url: "/api/ext/order/aggreeAllRefund",
    method: "post",
    data: params,
  });
};
export const orderAuditRefund = (params) => {
  return ajax({
    url: "/api/ext/order/auditRefund",
    method: "post",
    data: params,
  });
};

export const orderApplyRefund = (params) => {
  return ajax({
    url: "/api/ext/order/applyRefund",
    method: "post",
    data: params,
  });
};

/**
 * 分页查询提现记录
 * @param {Object} params 请求参数
 * "withdrawStatus": 0, // 0:待审核 1:已审核 2:已拒绝 3:已取消 4:已退款 5:已打款
 * "pageNum": 1,
 * "pageSize": 10,
 * @returns {Promise} { list, total }
 */
export const getWithdrawRecord = (params) => {
  return ajax({
    url: "/api/withdraw/record/page",
    method: "post",
    data: params,
  });
};

export const getWithdrawDetail = (id) => {
  return ajax({
    url: `/api/withdraw/record/detail/${id}`,
    method: "get",
  });
};
/**
 * 获取提现每日限额
 * @param {Object} params 请求参数
 * @returns {Promise} { dailyLimit }
 */
export const getWithdrawDailyLimit = (params) => {
  return ajax({
    url: "/api/withdraw/daily/limit",
    method: "get",
    params,
  });
};

/**
 * 绑定银行卡
 * @param {Object} params 请求参数
 * @returns {Promise} { success, message }
 */
export const bindCard = (params) => {
  return ajax({
    url: "/api/bankCard/bind",
    method: "post",
    data: params,
  });
};

export const getBankList = (params) => {
  return ajax({
    url: "/api/bank/list",
    method: "post",
    data: params,
  });
};

export const getBankCardList = (params) => {
  return ajax({
    url: "/api/bankCard/list",
    method: "post",
    data: params,
  });
};

export const applyWithdraw = (params) => {
  return ajax({
    url: "/api/withdraw/apply",
    method: "post",
    data: params,
  });
};
